import { useStarred } from "../lib/StarredContext";
import StationList from "./StationList";

export default function StarredStations() {
  const { starred } = useStarred();
  return <StationList stations={starred} emptyMessage="No starred stations yet. Click ☆ next to a station to star it." />;
}
